module.exports = __webpack_public_path__ + "img/1f417.9c46657.svg";